/**
 * NFD decompose, strip combining marks, map Polish ł → l.
 * Use for any short text field sent to checkout / Storefront / backend where we want the same encoding (names, city, etc.).
 */
export const normalizeInput = (value: string): string => {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L");
};

/**
 * US ZIP / ZIP+4 from autofill → 5-digit ZIP.
 * `12345-6789`, `123456789`, `12345` → `12345`
 */
export const normalizeUsZip = (value: string): string =>
  value.replace(/\D/g, "").slice(0, 5);
